import { render, staticRenderFns } from "./CustomDraggingList.vue?vue&type=template&id=56a6f32e&scoped=true"
import script from "./CustomDraggingList.vue?vue&type=script&lang=js"
export * from "./CustomDraggingList.vue?vue&type=script&lang=js"
import style0 from "./CustomDraggingList.vue?vue&type=style&index=0&id=56a6f32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a6f32e",
  null
  
)

export default component.exports